import { createSlice } from "@reduxjs/toolkit";
import { initialAuthSliceStateProps } from "../../../types/login";

const initialState: initialAuthSliceStateProps = {
  login_data: {
    userDocId: "",
    username: "",
    roles: [],
    type: "",
    token: "",
    refreshToken: "",
    exp: 0,
  },
  project_data: {
    projectAccessToken: "",
    projectRefreshToken: "",
    exp: 0,
  },
  userProfile_data: {
    _id: "",
    mobileNumber: "",
    defaultAppLanguage: "",
    isProfileUpdated: false,
    profileUpdateCount: 0,
    createdOn: "",
    __v: 0,
    DOB: "",
    alternateNumber: "",
    facebookLink: "",
    firstName: "",
    gender: "",
    lastName: "",
    middleName: "",
    updatedOn: "",
    whatsappNumber: "",
  },
  singleProject: {
    projectDocId: "",
    projectName: "",
    picUrl: "",
    onboardingStatus: "",
    isVerified: false,
    createdOn: "",
    createdBy: {
      personDocId: "",
      personName: "",
    },
  },
};
const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setLoginState: (state, action) => {
      state.login_data = action.payload;
    },
    setLogout: (state) => {
      state.login_data = {
        userDocId: "",
        username: "",
        roles: [],
        type: "",
        token: "",
        refreshToken: "",
        exp: 0,
      };
      state.project_data = {
        projectAccessToken: "",
        projectRefreshToken: "",
        exp: 0,
      };
      state.userProfile_data = {
        _id: "",
        mobileNumber: "",
        defaultAppLanguage: "",
        isProfileUpdated: false,
        profileUpdateCount: 0,
        createdOn: "",
        __v: 0,
        DOB: "",
        alternateNumber: "",
        facebookLink: "",
        firstName: "",
        gender: "",
        lastName: "",
        middleName: "",
        updatedOn: "",
        whatsappNumber: "",
      };
      window.location.replace("/login");
    },
    setProjectAuthData: (state, action) => {
      state.project_data = action.payload;
    },
    setUserProfileData: (state, action) => {
      state.userProfile_data = action.payload;
    },
    setSingleProject: (state, action) => {
      state.singleProject = action.payload;
    },
  },
});
export default authSlice.reducer;
export const {
  setLoginState,
  setLogout,
  setProjectAuthData,
  setUserProfileData,
  setSingleProject,
} = authSlice.actions;
